<template>
  <div>
    <label>Wybierz cechę:</label>

    <div class="flex-grid">
    <div v-for="field in fields" :key="field.field" @click="addField(field)" class="flex-item">
      <span v-if="field.label">{{field.label}}</span>
      <span v-else>{{field.dbfield}}</span>
    </div>
    </div>


  
    <!-- <button @click="addField">Dodaj do selekcji</button> -->

    <br>
    <br>
    <button @click="addLogicalCondition('AND')">I</button>
    <button @click="addLogicalCondition('OR')">LUB</button>
    <button @click="addLogicalCondition('NOT')">NIE</button>
    <button @click="addLogicalCondition('(')">(</button>
    <button @click="addLogicalCondition(')')">)</button>
    <button @click="removeLastCondition()">Usuń ostatni</button>
    <br>
    <br>

    <div class="conditions">
    <div class="condition" v-for="(condition, index) in conditions" :key="index">

      <section v-if="condition.type === 'field'">
          <span v-if="condition.field.label" class="aw400 field"> {{ condition.field.label }}</span>
          <span v-else class="aw400 field"> {{ condition.field.dbfield }}</span>
          
          <span class="aw600" v-if="condition.field.type === 'string'">
          od:
          <input class="w200" @change="generateSQL" v-if="condition.field.type === 'string'" type="text" v-model="condition.valueFrom" />
          do:
          <input class="w200" @change="generateSQL" v-if="condition.field.type === 'string'" type="text" v-model="condition.valueTo" />
          </span>

          <span class="aw600" @change="generateSQL" v-if="condition.field.type === 'number'">
          od:
          <input class="w200" @change="generateSQL" v-if="condition.field.type === 'number'" placeholder="liczba" type="text" v-model="condition.valueFrom" />
          do:
          <input class="w200" @change="generateSQL" v-if="condition.field.type === 'number'" placeholder="liczba" type="text" v-model="condition.valueTo" />
          </span>

          <span class="aw600" @change="generateSQL" v-if="condition.field.type === 'Date'">
          od:
          <input class="w200" @change="generateSQL" v-if="condition.field.type === 'Date'" type="date" v-model="condition.valueFrom" />
          do:
          <input class="w200" @change="generateSQL" v-if="condition.field.type === 'Date'" type="date" v-model="condition.valueTo" />
          </span>
        </section>

      <span v-if="condition.type === 'logical' && condition.logicalValue=='AND'"> i </span>
      <span v-if="condition.type === 'logical' && condition.logicalValue=='OR'"> lub</span>
      <span v-if="condition.type === 'logical' && condition.logicalValue=='NOT'">nie</span>
      <span v-if="condition.type === 'logical' && condition.logicalValue=='('">{{ condition.logicalValue }}</span>
      <span v-if="condition.type === 'logical' && condition.logicalValue==')'">{{ condition.logicalValue }}</span>
    </div>
    </div>
    <!-- <button @click="generateSQL">Generuj zapytanie</button> -->
    <div v-if="sqlQuery">
      <h3>Zapytanie:</h3>
      <span>{{ sqlQueryPl }}</span>
      <br>
       <code>{{ sqlQuery }}</code>
    </div>
  </div>
</template>

<script>

import { zlecenie_fields, IFieldInfo } from "./Fields"
import Bus from "@/lib/Bus";
const bus = new Bus().getBus();
/*
interface ICondition {
    type: string,
    field?: IFieldInfo | undefined,
    valueFrom?: any,
    valueTo?: any,
    logicalValue?: any
}
*/
export default {

  data() {
    return {
      x:"",
      fields:zlecenie_fields,
      selectedField: undefined,
      valueFrom: "",
      valueTo: "",
      conditions: [],
      sqlQuery: "",
      sqlQueryPl:""
    };
  },

  methods: {
    addField(field) {
      this.selectedField = field
      if (this.conditions.length>0) {
        const last = this.conditions[this.conditions.length-1]
        if (last.type=="field") {
            //AND
        }
      }
      if (this.selectedField) {
          const field = this.fields.find(f => f.dbfield === this.selectedField?.dbfield);
          if (!field) return;
          this.conditions.push({
            type: "field",
            field: field,
            valueFrom: field.valueFrom,
            valueTo: field.valueTo,
          });
      }
    },
    addCondition(condition) {
      this.conditions.push(condition);
      this.generateSQL()
    },
    addLogicalCondition(logic) {
      this.conditions.push({ type: "logical", logicalValue: logic });
      this.generateSQL()
    },
    removeLastCondition() {
      this.conditions.pop();
      this.generateSQL()
    },
    generateSQL() {
      const sqlWhere = this.conditions
        .map(item => {
          if (item.type === "field" ) {
            const field = this.fields.find(f => item.field && f.dbfield === item.field.dbfield);
            if (field) {
              if (item.valueTo!=undefined) {
                if (field.type === "number") {
                  return `(${item.field.table}.${item.field.dbfield} >= ${item.valueFrom} AND ${item.field.table}.${item.field.dbfield} <= ${item.valueTo})`;
                } else if (field.type === "string") {
                  return `(${item.field.table}.${item.field.dbfield} >= '${item.valueFrom}' AND ${item.field.table}.${item.field.dbfield} <= '${item.valueTo}')`;
                } else if (field.type === "Date") {
                  return `(${item.field.table}.${item.field.dbfield} >= '${item.valueFrom}' AND ${item.field.table}.${item.field.dbfield} <= '${item.valueTo}')`;
                }
              } else {
                if (field.type === "number") {
                  return `${item.field.table}.${item.field.dbfield} = ${item.valueFrom}`;
                } else if (field.type === "string") {
                  return `${item.field.table}.${item.field.dbfield} LIKE '%${item.valueFrom}%'`;
                } else if (field.type === "Date") {
                  return `${item.field.table}.${item.field.dbfield} = '${item.valueFrom}'`;
                }
              }
            }
          } else {
            return item.logicalValue;
          }
        })
        .join(" \n ");


  const polishWhere = this.conditions
        .map(item => {
          if (item.type === "field" ) {
            const field = this.fields.find(f => item.field && f.dbfield === item.field.dbfield);
            if (field) {
              const fname=item.field.label ? item.field.label : item.field.dbfield

              if (item.valueTo!=undefined) {
                if (field.type === "number") {
                  return `(${fname} >= ${item.valueFrom} I ${fname} <= ${item.valueTo})`;
                } else if (field.type === "string") {
                  return `(${fname} >= '${item.valueFrom}' I ${fname} <= '${item.valueTo}')`;
                } else if (field.type === "Date") {
                  return `(${fname} >= '${item.valueFrom}' I ${fname} <= '${item.valueTo}')`;
                }
              } else {
                if (field.type === "number") {
                  return `${fname} = ${item.valueFrom}`;
                } else if (field.type === "string") {
                  return `${fname} zawiera '%${item.valueFrom}%'`;
                } else if (field.type === "Date") {
                  return `${fname} = '${item.valueFrom}'`;
                }
              }
            }
          } else {
            if (item.logicalValue=="AND") return "I";
            else if (item.logicalValue=="OR") return "LUB";
            else if (item.logicalValue=="NOT") return "NIE";
            else return item.logicalValue;
          }
        })
        .join(" \n ");



      this.sqlQuery = ``;
      this.sqlQueryPl = '';
      if (sqlWhere.length==0) return;

      const sel = `
      SELECT TOP 1000  
        dbo.typ_zamowienia_od_odbiorcy.typdok_idn, 
        dbo.odbiorca.odbiorca_idn, 
        dbo.wytwor.nazwa, 
        dbo.zamodb.dok_idm,
        dbo.pp_zlecprod.zlecprod_idm,
        dbo.ut_grs_etykiety_z_wszystkimi_cechami.indeks_etykiety, 
      dbo.ut_grs_etykiety_z_wszystkimi_cechami.nr_ind_klienta,
        dbo.ut_grs_etykiety_z_wszystkimi_cechami.nazwa_etykiety, 
        dbo.ut_grs_etykiety_z_wszystkimi_cechami.wykrojnik, 
        dbo.ut_grs_etykiety_z_wszystkimi_cechami.wymiar_x, 
        dbo.ut_grs_etykiety_z_wszystkimi_cechami.wymiar_y, 
        dbo.ut_grs_etykiety_z_wszystkimi_cechami.surowiec_handlowy_a
    FROM            
        dbo.ut_grs_etykiety_z_wszystkimi_cechami
        LEFT JOIN dbo.zamodbpoz ON ut_grs_etykiety_z_wszystkimi_cechami.wytwor_id = dbo.zamodbpoz.wytwor_id
        INNER JOIN dbo.zamodb ON dbo.zamodb.zamodb_id = dbo.zamodbpoz.zamodb_id 
        INNER JOIN dbo.typ_zamowienia_od_odbiorcy ON dbo.zamodb.typzamodb_id = dbo.typ_zamowienia_od_odbiorcy.typzamodb_id 
        INNER JOIN dbo.wytwor ON dbo.zamodbpoz.wytwor_id = dbo.wytwor.wytwor_id 
        INNER JOIN dbo.odbiorca ON dbo.zamodb.odbiorca_id = dbo.odbiorca.odbiorca_id
      LEFT JOIN dbo.pp_zlecprod on dbo.pp_zlecprod.zamodb_id = dbo.zamodbpoz.zamodb_id
      `

      this.sqlQuery = `${sel} WHERE ${sqlWhere}`;

      this.sqlQueryPl = "Wyszukaj zlecenia spełniające warunek: "+polishWhere

     /*
      this.sqlQuery = this.sqlQuery.replace(/\bnumer_zlecenia\b/g, 'zlecenie.zlecprod_idm');
      this.sqlQuery = this.sqlQuery.replace(/\bdata_zatwierdzenia_zlecenia\b/g, 'zlecenie.data_zatw');
      this.sqlQuery = this.sqlQuery.replace(/\bwytwor_id\b/g, 'zlecenie.wytwor_id');
      this.sqlQuery = this.sqlQuery.replace(/\bzlecenie.zlecenie.wytwor_id\b/g, 'zlecenie.wytwor_id');
      this.sqlQuery = this.sqlQuery.replace(/\but_grs_etykiety_z_wszystkimi_cechami.zlecenie.wytwor_id\b/g, 'ut_grs_etykiety_z_wszystkimi_cechami.wytwor_id')
      */

      bus.fire("zlecenie_sql",{ sql: this.sqlQuery, conditions: this.conditions})
    }
    , computed: {
    fieldType() {
      if (this.selectedField) {
        const field = this.fields.find(f => f.dbfield === this.selectedField?.dbfield);
        return field ? field.type : "";
      }
      return "";
    }
  },
  }
};
</script>

<style>

  .aw400 {
    display:inline-block;
    width: 300px;
  }
  .aw600 {
    display:inline-block;
    width: 600px;
  }
  .condition {
    display: block;
    text-align: left;
  }
  .conditions {
    width: 800px;
    margin: auto;

  }

  /* Highlight condition.field */
  .field {
    color: black;
    font-weight: bold;
    width: 200px;
  }

  /* Style parenthesis */
  .parenthesis {
    color: #ff6600; /* Orange */
  }

  /* Style logical conditions */
  .logical {
    font-weight: bold;
    color: #3366ff; /* Blue */
  }

.flex-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 10px;
  font-weight: 700;
  max-height:300px;
  overflow-y:auto;
}

.flex-item {
  width: 150px;
  margin: 5px;
  padding: 5px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  transition: background-color 0.3s; /* Add a smooth transition effect */
}

.flex-item:hover {
  background-color: #f0f8ff;
}
</style>